import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem} from '../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../shared/Models/columns';
import * as moment from 'moment';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../shared/Services/broadcast.service';
import {Helper} from '../../../helpers/helper.service';
import {AuthenticationService} from '../../../shared/Services/authentication.service';
import {PackagingLabelService} from '../../Services/packaging-label.service';
import {environment} from '../../../../environments/environment';
import {Router} from '@angular/router';
import {DealersService} from '../../Services/dealers.service';
import {PackagingLabel} from '../../Models/PackagingLabel';

@Component({
  selector: 'app-packaging-label',
  templateUrl: './packaging-label.component.html',
  styleUrls: ['./packaging-label.component.scss']
})
export class PackagingLabelComponent implements OnInit {

  public grid: Grid;
  public baseUrl = environment.apiUrl;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  @ViewChild('generateModal', {static: false}) generateModal;
  @ViewChild('packingListNumberTemp', {static: true}) packingListNumberTemp;
  public specialButtons = [];
  public packagingLabel = new PackagingLabel();
  constructor(
    private packagingLabelService: PackagingLabelService,
    private translate: TranslateService,
    private broadcastService: BroadcastService,
    private helper: Helper,
    private router: Router,
    private auth: AuthenticationService,
    private dealersService: DealersService,
    private translator: TranslateService,
  ) { }

  ngOnInit() {
    const dateFormat = this.auth.getDateFormat();
    this.specialButtons.push({
      btnIcon: 'fa fa-plus',
      btnName: this.translator.instant('global.generate'),
      btnUrl: '',
      method: 'openGeneratePackagingLabelModal',
      btnCustomClass: 'btn btn-grey btn-outline-primary ripple light'
    });
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.backoffice.packaging-label.date',
          prop: 'date',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.backoffice.packaging-label.number',
          prop: 'id',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueTemplate: this.packingListNumberTemp,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.packaging-label.dealer-name',
          prop: 'deliveryDealer.companyName',
          sortable: false,
          type: TextColumn.type,
          translate: true,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-download fa-lg',
              tooltip: 'global.download',
              onclick: (row) => {
                if (row.labelFile) {
                  this.packagingLabelService.getPackagingLabelPdf(row.labelFile.path, row.labelFile.filename).subscribe(() => {});
                }
              },
              btnClass: 'ripple light'
            },
          ]
        },
      ],
      service: this.packagingLabelService,
      rememberURL: this.router.url,
      method: 'getPackagingLabel',
      defaultSort: 'id',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          calendarFromDate: 'from',
          calendarToDate: 'to',
          hasCalendar: true,
          hasNormalSearch: true,
        }
      ],
    };
  }

  callFunction(method) {
    this[method]();
  }

  openGeneratePackagingLabelModal() {
    this.generateModal.showDialog();
  }

  refreshGid(event) {
    if (event) {
      this.broadcastService.broadcast('refreshGrid', 'getPackagingLabel');
    }
  }
}
